export enum Role {
    HO = 'Head Office',
    Branch = 'Branch',
    Customer = 'Customer'
}
